/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RocketOrderOutboundSummaryInfoVo } from './RocketOrderOutboundSummaryInfoVo';
import {
    RocketOrderOutboundSummaryInfoVoFromJSON,
    RocketOrderOutboundSummaryInfoVoFromJSONTyped,
    RocketOrderOutboundSummaryInfoVoToJSON,
    RocketOrderOutboundSummaryInfoVoToJSONTyped,
} from './RocketOrderOutboundSummaryInfoVo';

/**
 * 
 * @export
 * @interface ResponseListRocketOrderOutboundSummaryInfoVo
 */
export interface ResponseListRocketOrderOutboundSummaryInfoVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListRocketOrderOutboundSummaryInfoVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListRocketOrderOutboundSummaryInfoVo
     */
    message?: string;
    /**
     * 
     * @type {Array<RocketOrderOutboundSummaryInfoVo>}
     * @memberof ResponseListRocketOrderOutboundSummaryInfoVo
     */
    data?: Array<RocketOrderOutboundSummaryInfoVo>;
}

/**
 * Check if a given object implements the ResponseListRocketOrderOutboundSummaryInfoVo interface.
 */
export function instanceOfResponseListRocketOrderOutboundSummaryInfoVo(value: object): value is ResponseListRocketOrderOutboundSummaryInfoVo {
    return true;
}

export function ResponseListRocketOrderOutboundSummaryInfoVoFromJSON(json: any): ResponseListRocketOrderOutboundSummaryInfoVo {
    return ResponseListRocketOrderOutboundSummaryInfoVoFromJSONTyped(json, false);
}

export function ResponseListRocketOrderOutboundSummaryInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListRocketOrderOutboundSummaryInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(RocketOrderOutboundSummaryInfoVoFromJSON)),
    };
}

export function ResponseListRocketOrderOutboundSummaryInfoVoToJSON(json: any): ResponseListRocketOrderOutboundSummaryInfoVo {
    return ResponseListRocketOrderOutboundSummaryInfoVoToJSONTyped(json, false);
}

export function ResponseListRocketOrderOutboundSummaryInfoVoToJSONTyped(value?: ResponseListRocketOrderOutboundSummaryInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(RocketOrderOutboundSummaryInfoVoToJSON)),
    };
}

